import type { RouteLocation, RouteRecordRaw } from 'vue-router';
import { RouteNames } from './routeNames';
import NoLeftSpaceLayout from '@/layouts/NoLeftSpaceLayout.vue';
import bootstrapTasksRoutes from '@/modules/bootstrapTasks/router';
import wizardsRoutes from '@/modules/wizards/router';

const routes: RouteRecordRaw = {
  path: '/app',
  name: RouteNames.APP_SHEL,
  component: NoLeftSpaceLayout,
  redirect: (to: RouteLocation) => {
    if ((to.query.code && to.query.state) || to.query.error || to.query.errorCode) {
      return { name: RouteNames.POST_LOGIN };
    }
    return to;
  },
  children: [
    {
      path: 'post',
      redirect: { name: RouteNames.POST_LOGIN },
    },
    {
      path: 'postLogoutPorch',
      redirect: { name: RouteNames.POST_LOGOUT },
    },
    bootstrapTasksRoutes,
    wizardsRoutes,
  ],
};

export default routes;
